import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { Checkbox } from '../reutilizables/checkbox/Checkbox'
import * as publicacionesService from '../servicios/publicacionesTemporalesService'
import InputLabel from '../ui/InputLabel'
import LinkButton from '../ui/LinkButton'
import Select from '../ui/Select'
import PrecioRango from './PrecioRango'

const IndicarPrecio = ({ values, onChange, onChangeState }) => {
  const [monedas, setMonedas] = useState([])
  const [unidades, setUnidades] = useState([])

  useEffect(() => {
    const obtenerDatos = async () => {
      const monedasRtn = await publicacionesService.buscarMoneda()
      setMonedas(monedasRtn.data)

      const unidadesRtn = await publicacionesService.buscarUnidad()
      setUnidades(unidadesRtn.data)
    }

    obtenerDatos()
  }, [])

  const handleTipoPrecio = function (e) {
    onChangeState('conStock', e.target.value === '1')
    onChangeState('conStockAPedido', e.target.value === '2')
    onChangeState('conPresupuesto', e.target.value === '3')
  }

  const handleAgregarPrecio = (e) => {
    e.preventDefault()
    const idUnidadMedida =
      values.preciosMayorista.length === 0 ? 0 : values.preciosMayorista[0].idUnidadMedida

    onChangeState('preciosMayorista', [
      ...values.preciosMayorista,
      {
        cantidad: 0,
        idUnidadMedida: idUnidadMedida,
        precio: 0,
        id: values.preciosMayorista.length
      }
    ])
  }

  const handleChangeRango = ({ currentTarget }, id) => {
    const clon = [...values.preciosMayorista]
    const indice = clon.findIndex((p) => p.id === id)
    clon[indice] = {
      ...clon[indice],
      [currentTarget.name]: Number(currentTarget.value),
      id: id
    }
    onChangeState('preciosMayorista', clon)
  }

  return (
    <>
      <p className="descripcion-cuadro-publicacion">Indicá el precio y stock de tu producto.</p>
      <div className="row">
        <div className="col-12 col-md-auto mb-2 mb-md-0">
          <Checkbox
            name="conStock"
            type="checkbox"
            value="1"
            className="mr-1"
            checked={values.conStock}
            onChange={handleTipoPrecio}
          />
          <span className="mr-3">Con Stock</span>
        </div>
        <div className="col-12 col-md-auto mb-2 mb-md-0">
          <Checkbox
            name="conStockAPedido"
            type="checkbox"
            value="2"
            className="mr-1"
            checked={values.conStockAPedido}
            onChange={handleTipoPrecio}
          />
          <span className="mr-3">A Pedido</span>
        </div>
        <div className="col-12 col-md-auto">
          <Checkbox
            name="conPresupuesto"
            type="checkbox"
            value="3"
            className="mr-1"
            checked={values.conPresupuesto}
            onChange={handleTipoPrecio}
          />
          <span>Presupuesto</span>
        </div>
      </div>
      {(values.conStock || values.conStockAPedido) && (
        <>
          <div className="row">
            <div className="col-12 col-md-6">
              {(values.conStock || values.conStockAPedido) && (
                <>
                  <br />
                  <InputLabel
                    type="number"
                    name="cantDisponible"
                    value={values.cantDisponible}
                    onChange={(e) => onChange(e, 'num')}
                    label="Cantidad Disponible:"
                    classNameInput="publicacion-precio w-10"
                    classNameLabel="mr-2"
                    error="Completar Cantidad Disponible"
                    onFocusSelected
                  />
                </>
              )}
              {values.conStockAPedido && (
                <>
                  <br />
                  <div className="d-none d-md-block">
                    <InputLabel
                      type="number"
                      name="cantMinPedido"
                      value={values.cantMinPedido}
                      onChange={(e) => onChange(e, 'num')}
                      label="Cantidad Mínima de Pedido:"
                      classNameInput="publicacion-precio"
                      classNameLabel="mr-2"
                      error="Completar Cantidad Mínima de Pedido"
                      onFocusSelected
                    />
                  </div>
                  <div className="d-block d-md-none">
                    <InputLabel
                      type="number"
                      name="cantMinPedido"
                      value={values.cantMinPedido}
                      onChange={(e) => onChange(e, 'num')}
                      label="Cant Mín Pedido:"
                      classNameInput="publicacion-precio w-20"
                      classNameLabel="mr-2"
                      error="Completar Cantidad Mínima de Pedido"
                      onFocusSelected
                    />
                  </div>
                </>
              )}
            </div>
            <div className="col d-none d-md-block">
              <br />
              <label className="mr-2" htmlFor="idMoneda">
                Moneda:
              </label>
              <Select
                name="idMoneda"
                onChange={(e) => onChange(e, 'num')}
                className="select-publicacion moneda-publicacion"
                datos={monedas}
                optionMetaDatos={{ value: 'idMoneda', text: 'nombre' }}
                optionPorDefecto={{ value: '0', text: 'Elegir Moneda' }}
                value={values.idMoneda}
              />
            </div>
            <div className="col d-block d-md-none">
              <label htmlFor="idMoneda" className="mr-2">
                Moneda:
              </label>
              <Select
                name="idMoneda"
                onChange={(e) => onChange(e, 'num')}
                className="select-publicacion-chico w-50 moneda-publicacion"
                datos={monedas}
                optionMetaDatos={{ value: 'idMoneda', text: 'nombre' }}
                optionPorDefecto={{ value: '0', text: 'Elegir Moneda' }}
                value={values.idMoneda}
              />
            </div>
          </div>
          {values.conStockAPedido && (
            <div className="row">
              <div className="col d-none d-md-block">
                <InputLabel
                  type="number"
                  name="capacidadMax"
                  value={values.capacidadMax}
                  onChange={(e) => {
                    onChange(e, 'num')
                  }}
                  label="Capacidad Máxima:"
                  classNameInput="publicacion-precio"
                  classNameLabel="mr-2"
                  error="Completar Capacidad Máxima"
                  onFocusSelected
                />
              </div>
              <div className="col-12 d-block d-md-none">
                <InputLabel
                  type="number"
                  name="capacidadMax"
                  value={values.capacidadMax}
                  onChange={(e) => onChange(e, 'num')}
                  label="Cap Máx:"
                  classNameInput="publicacion-precio w-10"
                  classNameLabel="mr-2"
                  error="Completar Capacidad Máxima"
                  onFocusSelected
                />
              </div>
              <div className="col">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4 d-none d-md-block">
                    Tiempo de Producción
                  </div>
                  <div className="col-4 col-sm-6 col-md-12 col-lg-12 col-xl-4 d-block d-md-none">
                    Produccion
                  </div>
                  <div className="col d-block d-md-none">
                    <select
                      name="tipoProducionCant"
                      id=""
                      className="select-publicacion-chico d-inline"
                      required=""
                      onChange={(e) => onChange(e, 'num')}
                      value={values.tipoProducionCant}
                    >
                      <option value="0">Elegir</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                      <option value="10">10</option>
                    </select>
                    <select
                      name="tipoProducionUnidad"
                      id=""
                      className="select-publicacion-chico"
                      required=""
                      onChange={(e) => onChange(e, 'num')}
                      value={values.tipoProducionUnidad}
                    >
                      <option value="0">Elegir</option>
                      <option value="1">hora</option>
                      <option value="2">dia</option>
                      <option value="3">semana</option>
                      <option value="4">mes</option>
                      <option value="5">año</option>
                    </select>
                  </div>
                  <div className="col d-none d-md-block">
                    <input
                      type="number"
                      name="tipoProducionCant"
                      className="select-publicacion-chico d-inline me-2"
                      style={{ width: '4.8rem', height: '2.7rem' }}
                      required
                      onChange={(e) => onChange(e, 'num')}
                      value={values.tipoProducionCant}
                    />

                    <select
                      name="tipoProducionUnidad"
                      id=""
                      className="select-publicacion-chico d-inline"
                      style={{ width: '4.8rem', height: '2.7rem' }}
                      required=""
                      onChange={(e) => onChange(e, 'num')}
                      value={values.tipoProducionUnidad}
                    >
                      <option value="0">Elegir</option>
                      <option value="1">hora</option>
                      <option value="2">dia</option>
                      <option value="3">semana</option>
                      <option value="4">mes</option>
                      <option value="5">año</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          )}
          <br />
          <div className="row">
            <div className="col-12">
              <InputLabel
                type="number"
                name="precioUnitario"
                value={values.precioUnitario}
                onChange={(e) => onChange(e, 'num')}
                label={
                  <>
                    Precio Minorista:
                    <i className="fa fa-usd" aria-hidden="true" />
                  </>
                }
                classNameInput="publicacion-precio w-10"
                classNameLabel="mr-2"
                error="Completar Precio Minorista"
                onFocusSelected
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <InputLabel
                type="number"
                name="alicuota"
                value={values.alicuota}
                onChange={(e) => onChange(e, 'num')}
                label="Alicuota:"
                classNameInput="publicacion-precio w-10"
                classNameLabel="mr-2"
                error="Completar Alicuota"
                onFocusSelected
                step="0.1"
              />
              <i className="fa fa-percent" aria-hidden="true" />
            </div>
          </div>
          <br />
          Precio Mayorista
          {values.preciosMayorista.map((rango, index) => (
            <PrecioRango
              key={index}
              id={index}
              values={rango}
              unidades={unidades}
              onChange={(e) => handleChangeRango(e, index)}
            />
          ))}
          <div className="ml-3 f-size-20">
            <LinkButton className="btn f-ebm-green" onClick={handleAgregarPrecio}>
              <i className="fa fa-plus" aria-hidden="true" />
            </LinkButton>
          </div>
        </>
      )}
      {values.conPresupuesto && (
        <>
          <div className="col d-none d-md-block">
            <br />
            <label htmlFor="idMoneda" className="mr-2">
              Moneda:
            </label>
            <Select
              name="idMoneda"
              onChange={(e) => onChange(e, 'num')}
              className="select-publicacion moneda-publicacion"
              datos={monedas}
              optionMetaDatos={{ value: 'idMoneda', text: 'nombre' }}
              optionPorDefecto={{ value: '0', text: 'Elegir Moneda' }}
              value={values.idMoneda}
            />
          </div>
          <div className="col d-block d-md-none">
            <label htmlFor="idMoneda" className="mr-2">
              Moneda:
            </label>
            <Select
              name="idMoneda"
              onChange={(e) => onChange(e, 'num')}
              className="select-publicacion-chico w-50 moneda-publicacion"
              datos={monedas}
              optionMetaDatos={{ value: 'idMoneda', text: 'nombre' }}
              optionPorDefecto={{ value: '0', text: 'Elegir Moneda' }}
              value={values.idMoneda}
            />
          </div>
          <div className="row">
            <div className="col-12">
              <InputLabel
                type="number"
                name="alicuota"
                value={values.alicuota}
                onChange={(e) => onChange(e, 'num')}
                label="Alicuota:"
                classNameInput="publicacion-precio w-10"
                classNameLabel="mr-2"
                error="Completar Alicuota"
                onFocusSelected
                step="0.1"
              />
              <i className="fa fa-percent" aria-hidden="true" />
            </div>
          </div>
        </>
      )}
    </>
  )
}

IndicarPrecio.propTypes = {
  values: PropTypes.shape({
    conStock: PropTypes.bool,
    conStockAPedido: PropTypes.bool,
    conPresupuesto: PropTypes.bool,
    cantDisponible: PropTypes.number,
    cantMinPedido: PropTypes.number,
    capacidadMax: PropTypes.number,
    idMoneda: PropTypes.number,
    precioUnitario: PropTypes.number,
    alicuota: PropTypes.number,
    tipoProducionCant: PropTypes.number,
    tipoProducionUnidad: PropTypes.number,
    preciosMayorista: PropTypes.arrayOf(
      PropTypes.shape({
        cantidad: PropTypes.number,
        idUnidadMedida: PropTypes.number,
        precio: PropTypes.number,
        id: PropTypes.number
      })
    )
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onChangeState: PropTypes.func.isRequired
}

export default IndicarPrecio
